import videoDetail from '@/pages/qcwy/videoDetail.vue';
import customerService from '@/pages/qcwy/customerService.vue';
import liveReplay from '@/pages/qcwy/liveReplay.vue';
import jumpTo from '@/pages/qcwy/jumpToApp.vue';
import jumpApplet from "@/pages/qcwy/Jumpapplet.vue"


const qcwy = [
  {
    path: '/qcwy/videoDetail',
    name: 'videoDetail',
    component: videoDetail,
    meta: {
      title: '视频详情'
    }
  },
  {
    path: '/qcwy/customerService',
    name: 'customerService',
    component: customerService,
    meta: {
      title: '客服'
    }
  },
  {
    path: '/qcwy/liveReplay',
    name: 'liveReplay',
    component: liveReplay,
    meta: {
      title: '回放'
    }
  },
  {
    path:'/qcwy/jumpTo',
    name: 'jumpTo',
    component: jumpTo,
    meta: {
      title: '下载'
    }
  },
  {
    path:'/qcwy/jumpApplet',
    name: 'jumpApplet',
    component: jumpApplet,
    meta: {
      title: '跳转小程序'
    }
  }
];


export default qcwy;



// WEBPACK FOOTER //
// ./src/router/modules/qcwy.js